import axios from 'axios';

export const JSON_HEADERS = { headers: { 'Content-Type': 'application/json' } };

export const backendUrl = () => window.env.REACT_APP_BACKEND_URL;

export async function apiRequest({ method, url, data, errorPrefix, attachError = false, headers = JSON_HEADERS, signal }) {
  let response = [];
  try {
    const config = signal ? { ...headers, signal } : headers;
    const result = method === 'get' || method === 'delete' ? await axios[method](url, config) : await axios[method](url, data, config);
    response = result;
  } catch (ex) {
    if (ex?.name === 'CanceledError' || ex?.name === 'AbortError' || (typeof axios.isCancel === 'function' && axios.isCancel(ex))) {
      throw ex;
    }
    console.log(errorPrefix, ex.message);
    if (attachError) response.error = ex.response?.data;
  }
  return response;
}
